var _path, _path2, _rect, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVcf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H19.5858L29 10.4142V39H1V1Z",
    fill: "white",
    stroke: "#EAEAEA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9V2.41421L27.5858 9H21Z",
    fill: "white",
    stroke: "#EAEAEA",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11,
    width: 30,
    height: 12,
    fill: "#8E44AD"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 20,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 7.5,
    fontWeight: 700,
    fill: "white",
    textAnchor: "middle"
  }, "VCF")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVcf);
export default __webpack_public_path__ + "static/media/vcf.56f33b834a76a467d454bd521b67f4cf.svg";
export { ForwardRef as ReactComponent };